import Participant from "./participant";

class ParticipantsList {
  private list: globalThis.Map<string, Participant>;

  constructor(_list?: ParticipantsList) {
    this.list = new Map<string, Participant>();
    if (_list) {
      _list.forEach((item) => this.set(item));
    }
  }
  // Use betId as key to allow multiple bets per wallet
  set(participant: Participant) {
    const key = participant.betId || participant.wallet.toString();
    this.list.set(key, participant);
    return this;
  }

  delete(wallet: string) {
    this.list.delete(wallet);
    return this;
  }

  map(fn: (itam: any, index: number) => any) {
    return Array.from(this.list.values()).reverse().map(fn);
  }

  forEach(fn: (itam: any, index: number) => any) {
    Array.from(this.list.values()).reverse().forEach(fn);
  }

  getByWallet(wallet: string) {
    return this.list.get(wallet);
  }

  getList() {
    return this;
  }

  size() {
    return this.list.size;
  }
}

export default ParticipantsList;
